﻿import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObject } from "@models/configurators/kb-object";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { RuleContainer } from "@models/configurators/rule-container";
import { IReferencedConfigurator } from "@models/entity-models";

@Kbo(CToken.ReferencedConfigurator)
export class ReferencedConfigurator extends KbObject implements IReferencedConfigurator {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public idProduct: number;
    public ruleContainers: RuleContainer[] = [];
    public userCanAddTo: string[] = [];
    public nestScene: boolean;
    public nestHotspots: boolean;
    public nestPriceObject: boolean;
    public element: string;

    public removeRuleContainer(rc: RuleContainer) {
        this.$manager.removeKbObject(rc);
        this.ruleContainers.remove(rc);
    }
}
